import { render, staticRenderFns } from "./degerlendirme.vue?vue&type=template&id=79b683a8"
import script from "./degerlendirme.vue?vue&type=script&lang=js"
export * from "./degerlendirme.vue?vue&type=script&lang=js"
import style0 from "./degerlendirme.vue?vue&type=style&index=0&id=79b683a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports